import type { SVGProps } from 'react';
import * as React from 'react';

const LinkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="solid/link">
      <g id="Icon">
        <path
          d="M14.6787 5.07858C15.8503 3.90701 17.7498 3.90701 18.9213 5.07858C20.0929 6.25016 20.0929 8.14965 18.9213 9.32122L17.4521 10.7904C17.1007 11.1419 17.1007 11.7117 17.4521 12.0632C17.8036 12.4147 18.3735 12.4147 18.7249 12.0632L20.1941 10.594C22.0687 8.7195 22.0687 5.68031 20.1941 3.80579C18.3196 1.93127 15.2804 1.93127 13.4059 3.80579L9.80591 7.40579C7.9314 9.28031 7.9314 12.3195 9.80591 14.194C9.89341 14.2815 9.98358 14.365 10.0762 14.4445C10.4533 14.7683 11.0215 14.7251 11.3453 14.348C11.6691 13.9709 11.6259 13.4027 11.2488 13.0789C11.1907 13.029 11.134 12.9765 11.0787 12.9212C9.90713 11.7496 9.90713 9.85015 11.0787 8.67858L14.6787 5.07858Z"
          fill="currentColor"
        />
        <path
          d="M13.9239 9.55524C13.5467 9.23144 12.9785 9.27467 12.6547 9.65179C12.3309 10.0289 12.3742 10.5971 12.7513 10.9209C12.8094 10.9708 12.8661 11.0233 12.9213 11.0786C14.0929 12.2501 14.0929 14.1496 12.9213 15.3212L9.32134 18.9212C8.14977 20.0928 6.25028 20.0928 5.0787 18.9212C3.90713 17.7496 3.90713 15.8501 5.0787 14.6786L6.54791 13.2094C6.89938 12.8579 6.89938 12.288 6.54791 11.9366C6.19643 11.5851 5.62659 11.5851 5.27511 11.9366L3.80591 13.4058C1.9314 15.2803 1.9314 18.3195 3.80591 20.194C5.68043 22.0685 8.71962 22.0685 10.5941 20.194L14.1941 16.594C16.0687 14.7195 16.0687 11.6803 14.1941 9.80578C14.1066 9.71828 14.0165 9.63475 13.9239 9.55524Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);
export default LinkIcon;
